import { useLocation, useNavigate } from 'react-router-dom';

const withRouterV6 = (Wrapped) => (props) => {
  const location  = useLocation();
  const navigate  = useNavigate();            // reemplaza a history
  return <Wrapped {...props} location={location} navigate={navigate} />;
};

export default withRouterV6